// Stub for drizzle-orm in client builds
export const sql = ((strings: TemplateStringsArray, ...values: any[]) => {
  if (typeof window !== 'undefined') {
    console.warn('drizzle-orm sql() called in client - this should not happen');
  }
  // Return a function that can be called (for sql`...`)
  const sqlFn: any = () => sqlFn;
  sqlFn.toString = () => '';
  return sqlFn;
}) as any;

